import { Action } from '@ngrx/store';

export enum AuthorizationActionTypes {
  AUTH_API_LOGGED_IN = '[Authorization API] Logged in',
}

export class AuthenticationModel {
  authorized: boolean;
}

export class AuthApiLoggedIn implements Action {
  readonly type = AuthorizationActionTypes.AUTH_API_LOGGED_IN;

  constructor(public payload: { access_token: string }) {}
}

export type AuthorizationActionsUnion = AuthApiLoggedIn;
